import React, { useState } from 'react';
import { ArrowLeft, Heart, Shield, User, MapPin, FileText, Zap, Building, DollarSign, Download, CheckCircle, AlertTriangle, Clock, Calculator } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { TrustBadge } from '../components/TrustBadge';
import { DocumentSection } from '../components/DocumentSection';
import { SocialShare } from '../components/SocialShare';
import { ContactSellerModal } from '../components/modals/ContactSellerModal';
import { ScheduleVisitModal } from '../components/modals/ScheduleVisitModal';
import { MessageModal } from '../components/modals/MessageModal';
import { ReviewsSection } from '../components/ReviewsSection';
import { QASection } from '../components/QASection';
import { Footer } from '../components/Footer';
export function ListingDetailPage() {
  const {
    id
  } = useParams();
  const [activeTab, setActiveTab] = useState('overview');
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [isFavorited, setIsFavorited] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const listingTitle = 'Premium Corner Plot in Hinjewadi Phase 1';
  const sellerName = 'Rajesh Kumar';
  const handleDownloadAll = () => {
    setIsMessageModalOpen(true);
  };
  const handleFavorite = () => {
    setIsFavorited(!isFavorited);
  };
  // Mock reviews data
  const mockReviews = [{
    id: '1',
    userName: 'Amit Sharma',
    userInitials: 'AS',
    rating: 5,
    date: '2024-01-15',
    verifiedTransaction: true,
    reviewText: 'Excellent property with clear documentation. The seller was very cooperative and transparent throughout the process. All documents were verified and genuine. Highly recommend!',
    sellerResponse: {
      text: 'Thank you for your kind words! It was a pleasure working with you.',
      date: '2024-01-16'
    },
    helpful: 12
  }, {
    id: '2',
    userName: 'Priya Patel',
    userInitials: 'PP',
    rating: 4,
    date: '2024-01-10',
    verifiedTransaction: true,
    reviewText: 'Good location and fair pricing. The plot is exactly as described. Only minor issue was some delay in getting the NA order copy, but overall satisfied with the purchase.',
    helpful: 8
  }, {
    id: '3',
    userName: 'Rohan Gupta',
    userInitials: 'RG',
    rating: 5,
    date: '2024-01-05',
    verifiedTransaction: false,
    reviewText: 'Great investment opportunity! The area is developing rapidly. Metro station coming up nearby will increase property value significantly.',
    helpful: 15
  }];
  // Mock Q&A data
  const mockQuestions = [{
    id: '1',
    userName: 'Priya Patel',
    userInitials: 'PP',
    question: 'Is the price negotiable? What is your best offer?',
    questionDate: '2024-01-10',
    answer: {
      text: 'Slight negotiation is possible for immediate closure. We are looking for a direct buyer without broker involvement. Please contact me to discuss.',
      date: '2024-01-11',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '2',
    userName: 'Amit Kumar',
    userInitials: 'AK',
    question: 'Is home loan available for this property? Which banks have approved it?',
    questionDate: '2024-01-08',
    answer: {
      text: 'Yes, the property is approved by SBI, HDFC, and ICICI Bank for home loans. All necessary documents for loan processing are available.',
      date: '2024-01-09',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '3',
    userName: 'Neha Singh',
    userInitials: 'NS',
    question: 'What is the current status of electricity and water connections?',
    questionDate: '2024-01-12',
    answer: {
      text: 'Electricity connection is already available at the plot boundary. Water connection from municipal corporation is available. Additionally, there is a functional borewell on the property.',
      date: '2024-01-12',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '4',
    userName: 'Vikram Desai',
    userInitials: 'VD',
    question: 'Are there any pending dues or legal issues with this property?',
    questionDate: '2024-01-14',
    answer: {
      text: 'No pending dues whatsoever. Property tax is paid up to date. Legal clearance certificate and encumbrance certificate for 30 years are available. No litigation history.',
      date: '2024-01-14',
      sellerName: 'Rajesh Kumar'
    }
  }];
  const tabs = [{
    id: 'overview',
    label: 'Overview',
    icon: FileText
  }, {
    id: 'location',
    label: 'Location',
    icon: MapPin
  }, {
    id: 'legal',
    label: 'Legal & Title',
    icon: Shield
  }, {
    id: 'infra',
    label: 'Infrastructure',
    icon: Zap
  }, {
    id: 'zoning',
    label: 'Zoning',
    icon: Building
  }, {
    id: 'financials',
    label: 'Financials',
    icon: DollarSign
  }, {
    id: 'documents',
    label: 'Documents',
    icon: FileText
  }, {
    id: 'reviews',
    label: 'Reviews',
    icon: FileText
  }, {
    id: 'qa',
    label: 'Q&A',
    icon: FileText
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4588">
      {/* Header Navigation */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12 sticky top-0 z-20" data-id="element-4589">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-4590">
          <Link to="/" className="flex items-center gap-2" data-id="element-4591">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4592"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-4593">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-4594">
            <Link to="/" data-id="element-4595">Buy Plots</Link>
            <Link to="/create-listing" data-id="element-4596">Sell Land</Link>
            <Link to="/legal-guides" data-id="element-4597">Legal Guides</Link>
            <Link to="/advocacy" data-id="element-4598">Advocacy</Link>
          </nav>
          <div className="flex gap-4" data-id="element-4599">
            <SocialShare url={window.location.href} title={listingTitle} description="2400 sq ft corner plot with clear title in Hinjewadi" data-id="element-4600" />
            <button onClick={handleFavorite} className={`p-2 border border-gray-300 rounded hover:bg-gray-50 ${isFavorited ? 'bg-red-50 border-red-300' : ''}`} data-id="element-4601">
              <Heart className={`w-4 h-4 ${isFavorited ? 'text-red-600 fill-red-600' : 'text-gray-600'}`} data-id="element-4602" />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl mx-auto px-4 md:px-6 py-8" data-id="element-4603">
        {/* Breadcrumb */}
        <div className="mb-4" data-id="element-4604">
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-4605">
            Home
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-4606">/</span>
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-4607">
            Listings
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-4608">/</span>
          <span className="text-sm text-gray-900" data-id="element-4609">{listingTitle}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-4610">
          {/* Main Content Column */}
          <div className="lg:col-span-8 space-y-6" data-id="element-4611">
            {/* Title Section */}
            <div className="bg-white border border-gray-300 p-6 md:p-8" data-id="element-4612">
              <div className="flex flex-col md:flex-row justify-between items-start gap-4 mb-6" data-id="element-4613">
                <div data-id="element-4614">
                  <div className="flex items-center gap-3 mb-2" data-id="element-4615">
                    <TrustBadge level="verified" data-id="element-4616" />
                    <span className="text-xs font-mono text-gray-500 uppercase" data-id="element-4617">
                      ID: CP-{id || '2491'}
                    </span>
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-800 text-[10px] font-bold uppercase rounded border border-blue-200" data-id="element-4618">
                      New to Market
                    </span>
                  </div>
                  <h1 className="text-3xl font-bold text-[#1f2933] mb-2" data-id="element-4619">
                    {listingTitle}
                  </h1>
                  <p className="text-gray-500 font-mono flex items-center gap-2" data-id="element-4620">
                    <MapPin className="w-4 h-4" data-id="element-4621" /> Sector 4, Hinjewadi, Pune,
                    Maharashtra 411057
                  </p>
                </div>
                <div className="text-right" data-id="element-4622">
                  <div className="text-3xl font-bold text-[#1f2933]" data-id="element-4623">
                    ₹ 45 Lakhs
                  </div>
                  <div className="text-sm text-gray-500 font-mono" data-id="element-4624">
                    ₹ 1,875 / sq.ft
                  </div>
                </div>
              </div>

              {/* Image Gallery */}
              <div className="grid grid-cols-4 gap-4 aspect-[2/1]" data-id="element-4625">
                <div className="col-span-4 md:col-span-3 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 font-mono h-full relative group cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-4626">
                  [Main Plot View]
                  <div className="absolute bottom-4 right-4 bg-black/70 text-white text-xs px-2 py-1 rounded font-bold" data-id="element-4627">
                    1/12 Photos
                  </div>
                </div>
                <div className="hidden md:flex flex-col gap-4 h-full" data-id="element-4628">
                  <div className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4629">
                    [Map View]
                  </div>
                  <div className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4630">
                    [Drone View]
                  </div>
                  <div className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4631">
                    [3D View]
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div className="bg-white border border-gray-300 sticky top-[73px] z-10 shadow-sm overflow-x-auto" data-id="element-4632">
              <div className="flex min-w-max" data-id="element-4633">
                {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-4 text-sm font-bold border-b-2 transition-colors ${activeTab === tab.id ? 'border-[#1f2933] text-[#1f2933] bg-gray-50' : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'}`} data-id="element-4634">
                    <tab.icon className="w-4 h-4" data-id="element-4635" />
                    {tab.label}
                  </button>)}
              </div>
            </div>

            {/* Tab Content - Keep existing tabs, add Reviews & Q&A */}
            <div className="bg-white border border-gray-300 p-6 md:p-8 min-h-[400px]" data-id="element-4636">
              {/* OVERVIEW TAB */}
              {activeTab === 'overview' && <div className="space-y-8 animate-in fade-in" data-id="element-4637">
                  <div data-id="element-4638">
                    <h2 className="text-xl font-bold mb-6 pb-2 border-b border-gray-200" data-id="element-4639">
                      Key Highlights
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4640">
                      {[{
                    label: 'Plot Area',
                    value: '2,400 Sq. Ft'
                  }, {
                    label: 'Dimensions',
                    value: '40 x 60 ft'
                  }, {
                    label: 'Facing',
                    value: 'North-East'
                  }, {
                    label: 'Road Width',
                    value: '12 Meters'
                  }, {
                    label: 'Zoning',
                    value: 'Residential (R-Zone)'
                  }, {
                    label: 'Ownership',
                    value: 'Freehold'
                  }, {
                    label: 'Boundary',
                    value: 'Fenced Wall'
                  }, {
                    label: 'Water',
                    value: 'Municipal + Borewell'
                  }].map((attr, i) => <div key={i} className="p-3 bg-gray-50 border border-gray-200" data-id="element-4641">
                          <dt className="text-xs font-mono text-gray-500 uppercase mb-1" data-id="element-4642">
                            {attr.label}
                          </dt>
                          <dd className="font-bold text-[#1f2933]" data-id="element-4643">
                            {attr.value}
                          </dd>
                        </div>)}
                    </div>
                  </div>

                  <div data-id="element-4644">
                    <h2 className="text-xl font-bold mb-4" data-id="element-4645">
                      About this Property
                    </h2>
                    <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4646">
                      Excellent investment opportunity in the heart of Hinjewadi
                      IT Park. This corner plot is fully sanctioned with NA
                      order and clear title. Located just 500 meters from the
                      upcoming Metro station and 2km from Wipro Circle. Ideal
                      for constructing a bungalow or G+3 residential apartments.
                    </p>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4647">
                      The plot has a 40ft wide road frontage and is surrounded
                      by developed societies. Electricity and water connections
                      are already available on site.
                    </p>
                  </div>

                  <div data-id="element-4648">
                    <h2 className="text-xl font-bold mb-4" data-id="element-4649">
                      Questions & Answers
                    </h2>
                    <div className="space-y-4" data-id="element-4650">
                      <div className="border border-dashed border-gray-200 p-4 bg-gray-50" data-id="element-4651">
                        <p className="font-bold text-sm mb-2" data-id="element-4652">
                          Q: Is the price negotiable?
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-4653">
                          A: Slight negotiation is possible for immediate
                          closure. We are looking for a direct buyer.
                        </p>
                      </div>
                      <div className="border border-dashed border-gray-200 p-4 bg-gray-50" data-id="element-4654">
                        <p className="font-bold text-sm mb-2" data-id="element-4655">
                          Q: Is loan available?
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-4656">
                          A: Yes, approved by SBI and HDFC.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}

              {/* LOCATION TAB */}
              {activeTab === 'location' && <div className="space-y-8 animate-in fade-in" data-id="element-4657">
                  <div className="aspect-video bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 font-mono" data-id="element-4658">
                    [Interactive Map Placeholder: Plot Boundary Overlay]
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4659">
                    <div data-id="element-4660">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4661">
                        Address Details
                      </h3>
                      <div className="space-y-3" data-id="element-4662">
                        {[{
                      label: 'Survey No.',
                      value: '45/2/A'
                    }, {
                      label: 'CTS No.',
                      value: '1240'
                    }, {
                      label: 'Village',
                      value: 'Maan'
                    }, {
                      label: 'Taluka',
                      value: 'Mulshi'
                    }, {
                      label: 'PIN Code',
                      value: '411057'
                    }].map((item, i) => <div key={i} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4663">
                            <span className="text-sm text-gray-500" data-id="element-4664">
                              {item.label}
                            </span>
                            <span className="font-mono font-bold text-sm" data-id="element-4665">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    <div data-id="element-4666">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4667">
                        Measurements & Boundary
                      </h3>
                      <div className="space-y-3" data-id="element-4668">
                        {[{
                      label: 'Plot Shape',
                      value: 'Regular (Rectangular)'
                    }, {
                      label: 'Frontage',
                      value: '40 ft'
                    }, {
                      label: 'Depth',
                      value: '60 ft'
                    }, {
                      label: 'Boundary Wall',
                      value: 'Present (6ft Height)',
                      color: 'green'
                    }, {
                      label: 'Corner Plot',
                      value: 'Yes (Two sides open)',
                      color: 'blue'
                    }].map((item, i) => <div key={i} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4669">
                            <span className="text-sm text-gray-500" data-id="element-4670">
                              {item.label}
                            </span>
                            <span className={`font-bold text-sm ${item.color === 'green' ? 'text-green-600' : item.color === 'blue' ? 'text-blue-600' : ''}`} data-id="element-4671">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div data-id="element-4672">
                    <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-4673">
                      <Calculator className="w-5 h-5" data-id="element-4674" /> Proximity Calculator
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-4675">
                      {[{
                    place: 'Metro Station',
                    dist: '0.5 km',
                    time: '5 min walk'
                  }, {
                    place: 'Wipro Circle',
                    dist: '2.0 km',
                    time: '10 min drive'
                  }, {
                    place: 'Pune Airport',
                    dist: '22 km',
                    time: '45 min drive'
                  }, {
                    place: 'Symbiosis College',
                    dist: '3.5 km',
                    time: '15 min drive'
                  }, {
                    place: 'Ruby Hall Clinic',
                    dist: '1.8 km',
                    time: '8 min drive'
                  }, {
                    place: 'Xion Mall',
                    dist: '1.2 km',
                    time: '5 min drive'
                  }].map((item, i) => <div key={i} className="p-3 border border-gray-200 bg-gray-50" data-id="element-4676">
                          <div className="text-xs text-gray-500 uppercase mb-1" data-id="element-4677">
                            {item.place}
                          </div>
                          <div className="font-bold text-lg" data-id="element-4678">{item.dist}</div>
                          <div className="text-xs text-gray-400" data-id="element-4679">
                            {item.time}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* LEGAL TAB */}
              {activeTab === 'legal' && <div className="space-y-8 animate-in fade-in" data-id="element-4680">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4681">
                    <div data-id="element-4682">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4683">
                        Ownership Details
                      </h3>
                      <div className="space-y-3" data-id="element-4684">
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4685">
                          <span className="text-sm text-gray-500" data-id="element-4686">
                            Ownership Type
                          </span>
                          <span className="font-bold text-sm" data-id="element-4687">Freehold</span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4688">
                          <span className="text-sm text-gray-500" data-id="element-4689">
                            Seller Type
                          </span>
                          <span className="font-bold text-sm" data-id="element-4690">
                            Individual Owner
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4691">
                          <span className="text-sm text-gray-500" data-id="element-4692">
                            Title Status
                          </span>
                          <span className="font-bold text-sm text-green-600" data-id="element-4693">
                            Clear & Marketable
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4694">
                          <span className="text-sm text-gray-500" data-id="element-4695">
                            Litigation History
                          </span>
                          <span className="font-bold text-sm text-green-600" data-id="element-4696">
                            None (NIL Certificate)
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 border border-gray-200 p-4" data-id="element-4697">
                      <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-4698">
                        <Shield className="w-5 h-5" data-id="element-4699" /> Risk Assessment
                      </h3>
                      <div className="space-y-4" data-id="element-4700">
                        <div data-id="element-4701">
                          <div className="flex justify-between text-sm mb-1" data-id="element-4702">
                            <span data-id="element-4703">Overall Risk Score</span>
                            <span className="font-bold text-green-600" data-id="element-4704">
                              Low Risk
                            </span>
                          </div>
                          <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-4705">
                            <div className="h-full bg-green-500 w-[90%]" data-id="element-4706"></div>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-2 text-center text-xs" data-id="element-4707">
                          <div className="p-2 bg-white border border-gray-200" data-id="element-4708">
                            <div className="font-bold text-green-600" data-id="element-4709">9/10</div>
                            <div className="text-gray-500" data-id="element-4710">Legal</div>
                          </div>
                          <div className="p-2 bg-white border border-gray-200" data-id="element-4711">
                            <div className="font-bold text-green-600" data-id="element-4712">
                              10/10
                            </div>
                            <div className="text-gray-500" data-id="element-4713">Title</div>
                          </div>
                          <div className="p-2 bg-white border border-gray-200" data-id="element-4714">
                            <div className="font-bold text-yellow-600" data-id="element-4715">
                              8/10
                            </div>
                            <div className="text-gray-500" data-id="element-4716">Compliance</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div data-id="element-4717">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4718">
                      Document Checklist
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4719">
                      {[{
                    cat: 'Ownership Proof',
                    items: ['Sale Deed', '7/12 Extract', 'Mutation Entry'],
                    status: 'verified'
                  }, {
                    cat: 'Approvals',
                    items: ['NA Order', 'Layout Plan', 'Zone Certificate'],
                    status: 'verified'
                  }, {
                    cat: 'Legal Clearances',
                    items: ['Encumbrance Cert (30 yrs)', 'Search Report', 'Public Notice'],
                    status: 'verified'
                  }, {
                    cat: 'Survey Docs',
                    items: ['Demarcation Map', 'Mojani Sketch'],
                    status: 'pending'
                  }].map((group, i) => <div key={i} className="border border-gray-200 p-4" data-id="element-4720">
                          <div className="flex justify-between items-center mb-3" data-id="element-4721">
                            <h4 className="font-bold text-sm" data-id="element-4722">{group.cat}</h4>
                            {group.status === 'verified' ? <span className="text-xs font-bold text-green-600 flex items-center gap-1" data-id="element-4723">
                                <CheckCircle className="w-3 h-3" data-id="element-4724" /> Verified
                              </span> : <span className="text-xs font-bold text-yellow-600 flex items-center gap-1" data-id="element-4725">
                                <Clock className="w-3 h-3" data-id="element-4726" /> Pending
                              </span>}
                          </div>
                          <ul className="space-y-1" data-id="element-4727">
                            {group.items.map((item, j) => <li key={j} className="text-xs text-gray-600 flex items-center gap-2" data-id="element-4728">
                                <span className="w-1.5 h-1.5 bg-gray-300 rounded-full" data-id="element-4729"></span>{' '}
                                {item}
                              </li>)}
                          </ul>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* INFRASTRUCTURE TAB */}
              {activeTab === 'infra' && <div className="space-y-8 animate-in fade-in" data-id="element-4730">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4731">
                    <div data-id="element-4732">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4733">Road & Access</h3>
                      <div className="space-y-3" data-id="element-4734">
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4735">
                          <span className="text-sm text-gray-500" data-id="element-4736">
                            Road Ownership
                          </span>
                          <span className="font-bold text-sm" data-id="element-4737">
                            Municipal Corporation
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4738">
                          <span className="text-sm text-gray-500" data-id="element-4739">
                            Road Surface
                          </span>
                          <span className="font-bold text-sm" data-id="element-4740">Concrete</span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4741">
                          <span className="text-sm text-gray-500" data-id="element-4742">
                            Road Width
                          </span>
                          <span className="font-bold text-sm" data-id="element-4743">
                            12 Meters (40 ft)
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4744">
                          <span className="text-sm text-gray-500" data-id="element-4745">
                            All-weather Access
                          </span>
                          <span className="font-bold text-sm text-green-600" data-id="element-4746">
                            Yes
                          </span>
                        </div>
                      </div>
                    </div>

                    <div data-id="element-4747">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4748">Utilities Grid</h3>
                      <div className="grid grid-cols-2 gap-4" data-id="element-4749">
                        <div className="p-3 border border-gray-200 bg-gray-50" data-id="element-4750">
                          <div className="flex items-center gap-2 mb-1" data-id="element-4751">
                            <Zap className="w-4 h-4 text-yellow-600" data-id="element-4752" />
                            <span className="font-bold text-sm" data-id="element-4753">
                              Electricity
                            </span>
                          </div>
                          <div className="text-xs text-gray-600" data-id="element-4754">
                            Available at site
                          </div>
                          <div className="text-[10px] text-gray-400" data-id="element-4755">
                            MSEDCL Grid
                          </div>
                        </div>
                        <div className="p-3 border border-gray-200 bg-gray-50" data-id="element-4756">
                          <div className="flex items-center gap-2 mb-1" data-id="element-4757">
                            <div className="w-4 h-4 text-blue-600 font-bold text-center leading-none" data-id="element-4758">
                              W
                            </div>
                            <span className="font-bold text-sm" data-id="element-4759">Water</span>
                          </div>
                          <div className="text-xs text-gray-600" data-id="element-4760">
                            Municipal + Borewell
                          </div>
                          <div className="text-[10px] text-gray-400" data-id="element-4761">
                            Potable Quality
                          </div>
                        </div>
                        <div className="p-3 border border-gray-200 bg-gray-50" data-id="element-4762">
                          <div className="flex items-center gap-2 mb-1" data-id="element-4763">
                            <div className="w-4 h-4 text-green-600 font-bold text-center leading-none" data-id="element-4764">
                              S
                            </div>
                            <span className="font-bold text-sm" data-id="element-4765">Sewerage</span>
                          </div>
                          <div className="text-xs text-gray-600" data-id="element-4766">
                            Underground Line
                          </div>
                          <div className="text-[10px] text-gray-400" data-id="element-4767">
                            Connected to Main
                          </div>
                        </div>
                        <div className="p-3 border border-gray-200 bg-gray-50" data-id="element-4768">
                          <div className="flex items-center gap-2 mb-1" data-id="element-4769">
                            <div className="w-4 h-4 text-purple-600 font-bold text-center leading-none" data-id="element-4770">
                              N
                            </div>
                            <span className="font-bold text-sm" data-id="element-4771">
                              Connectivity
                            </span>
                          </div>
                          <div className="text-xs text-gray-600" data-id="element-4772">
                            Fiber Available
                          </div>
                          <div className="text-[10px] text-gray-400" data-id="element-4773">
                            Jio / Airtel
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div data-id="element-4774">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4775">
                      Community Amenities
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4776">
                      {['Street Lights', 'CCTV Surveillance', 'Security Gate', 'Waste Collection', 'Paved Footpaths', 'Storm Water Drain'].map((item, i) => <div key={i} className="flex items-center gap-2 p-2 border border-dashed border-gray-200" data-id="element-4777">
                          <CheckCircle className="w-4 h-4 text-green-500" data-id="element-4778" />
                          <span className="text-sm text-gray-700" data-id="element-4779">{item}</span>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* ZONING TAB */}
              {activeTab === 'zoning' && <div className="space-y-8 animate-in fade-in" data-id="element-4780">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4781">
                    <div data-id="element-4782">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4783">
                        Land Use & Zoning
                      </h3>
                      <div className="space-y-3" data-id="element-4784">
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4785">
                          <span className="text-sm text-gray-500" data-id="element-4786">
                            Current Land Use
                          </span>
                          <span className="font-bold text-sm" data-id="element-4787">Residential</span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4788">
                          <span className="text-sm text-gray-500" data-id="element-4789">
                            Zoning Classification
                          </span>
                          <span className="font-bold text-sm" data-id="element-4790">
                            R-1 (Pure Residential)
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4791">
                          <span className="text-sm text-gray-500" data-id="element-4792">
                            Master Plan
                          </span>
                          <span className="font-bold text-sm" data-id="element-4793">
                            Pune DP 2027
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4794">
                          <span className="text-sm text-gray-500" data-id="element-4795">
                            Development Status
                          </span>
                          <span className="font-bold text-sm" data-id="element-4796">
                            Approved Layout
                          </span>
                        </div>
                      </div>
                    </div>

                    <div data-id="element-4797">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4798">
                        Building Regulations
                      </h3>
                      <div className="space-y-3" data-id="element-4799">
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4800">
                          <span className="text-sm text-gray-500" data-id="element-4801">
                            FSI / FAR
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4802">
                            1.5 (Expandable to 2.0)
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4803">
                          <span className="text-sm text-gray-500" data-id="element-4804">
                            Ground Coverage
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4805">
                            Max 40%
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4806">
                          <span className="text-sm text-gray-500" data-id="element-4807">
                            Height Restriction
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4808">
                            15 Meters (G+3)
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4809">
                          <span className="text-sm text-gray-500" data-id="element-4810">
                            Setbacks
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4811">
                            Front: 3m, Side: 1.5m
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-yellow-50 border border-yellow-200 p-4" data-id="element-4812">
                    <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-yellow-900" data-id="element-4813">
                      <AlertTriangle className="w-5 h-5" data-id="element-4814" /> Environmental
                      Constraints
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4815">
                      {[{
                    label: 'CRZ Zone',
                    val: 'No',
                    safe: true
                  }, {
                    label: 'Flood Zone',
                    val: 'No',
                    safe: true
                  }, {
                    label: 'High Tension Line',
                    val: 'None',
                    safe: true
                  }, {
                    label: 'Water Body',
                    val: '> 500m',
                    safe: true
                  }].map((item, i) => <div key={i} className="bg-white p-3 border border-yellow-100" data-id="element-4816">
                          <div className="text-xs text-gray-500 uppercase mb-1" data-id="element-4817">
                            {item.label}
                          </div>
                          <div className={`font-bold ${item.safe ? 'text-green-600' : 'text-red-600'}`} data-id="element-4818">
                            {item.val}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* FINANCIALS TAB */}
              {activeTab === 'financials' && <div className="space-y-8 animate-in fade-in" data-id="element-4819">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4820">
                    <div data-id="element-4821">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4822">
                        Price Breakdown
                      </h3>
                      <div className="bg-gray-50 border border-gray-200 p-4 space-y-3" data-id="element-4823">
                        <div className="flex justify-between items-center" data-id="element-4824">
                          <span className="text-sm text-gray-600" data-id="element-4825">
                            Asking Price
                          </span>
                          <span className="font-bold text-lg" data-id="element-4826">₹ 45,00,000</span>
                        </div>
                        <div className="flex justify-between items-center text-sm" data-id="element-4827">
                          <span className="text-gray-500" data-id="element-4828">
                            Price per Sq. Ft
                          </span>
                          <span className="font-mono" data-id="element-4829">₹ 1,875</span>
                        </div>
                        <div className="flex justify-between items-center text-sm" data-id="element-4830">
                          <span className="text-gray-500" data-id="element-4831">
                            Govt. Guideline Value
                          </span>
                          <span className="font-mono" data-id="element-4832">₹ 1,650 / sq.ft</span>
                        </div>
                        <div className="flex justify-between items-center text-sm pt-2 border-t border-gray-200" data-id="element-4833">
                          <span className="text-gray-500" data-id="element-4834">
                            Premium over Guideline
                          </span>
                          <span className="font-bold text-blue-600" data-id="element-4835">
                            +13.6%
                          </span>
                        </div>
                      </div>
                    </div>

                    <div data-id="element-4836">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4837">
                        Estimated Additional Costs
                      </h3>
                      <div className="space-y-3" data-id="element-4838">
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4839">
                          <span className="text-sm text-gray-500" data-id="element-4840">
                            Stamp Duty (6%)
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4841">
                            ₹ 2,70,000
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4842">
                          <span className="text-sm text-gray-500" data-id="element-4843">
                            Registration (1%)
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4844">
                            ₹ 45,000
                          </span>
                        </div>
                        <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4845">
                          <span className="text-sm text-gray-500" data-id="element-4846">
                            Development Charges
                          </span>
                          <span className="font-mono font-bold text-sm" data-id="element-4847">
                            ₹ 50,000
                          </span>
                        </div>
                        <div className="flex justify-between pt-2" data-id="element-4848">
                          <span className="font-bold text-sm" data-id="element-4849">
                            Total Estimated Cost
                          </span>
                          <span className="font-mono font-bold text-lg" data-id="element-4850">
                            ₹ 48,65,000
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div data-id="element-4851">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4852">
                      Market Intelligence
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-4853">
                      <div className="p-4 border border-green-200 bg-green-50" data-id="element-4854">
                        <div className="text-xs text-green-800 uppercase mb-1" data-id="element-4855">
                          3-Year Appreciation
                        </div>
                        <div className="text-2xl font-bold text-green-700" data-id="element-4856">
                          +28%
                        </div>
                        <div className="text-xs text-green-600" data-id="element-4857">
                          Avg. in Hinjewadi
                        </div>
                      </div>
                      <div className="p-4 border border-green-200 bg-green-50" data-id="element-4858">
                        <div className="text-xs text-green-800 uppercase mb-1" data-id="element-4859">
                          5-Year Appreciation
                        </div>
                        <div className="text-2xl font-bold text-green-700" data-id="element-4860">
                          +45%
                        </div>
                        <div className="text-xs text-green-600" data-id="element-4861">
                          Consistent Growth
                        </div>
                      </div>
                      <div className="p-4 border border-blue-200 bg-blue-50" data-id="element-4862">
                        <div className="text-xs text-blue-800 uppercase mb-1" data-id="element-4863">
                          Loan Eligibility
                        </div>
                        <div className="text-2xl font-bold text-blue-700" data-id="element-4864">
                          70% LTV
                        </div>
                        <div className="text-xs text-blue-600" data-id="element-4865">
                          Approved by SBI, HDFC
                        </div>
                      </div>
                    </div>

                    <div className="h-48 bg-gray-50 border-2 border-dashed border-gray-200 flex items-center justify-center text-gray-400 font-mono" data-id="element-4866">
                      [Price History Line Graph Placeholder]
                    </div>
                  </div>
                </div>}

              {/* DOCUMENTS TAB */}
              {activeTab === 'documents' && <div className="space-y-6 animate-in fade-in" data-id="element-4867">
                  <div className="flex justify-between items-center mb-4" data-id="element-4868">
                    <h2 className="text-xl font-bold" data-id="element-4869">Property Documents</h2>
                    <button onClick={handleDownloadAll} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4870">
                      <Download className="w-4 h-4" data-id="element-4871" /> Download All
                    </button>
                  </div>

                  <DocumentSection documents={[{
                name: '7/12 Extract (Satbara)',
                status: 'verified',
                date: 'Oct 12, 2023'
              }, {
                name: 'NA Order Copy',
                status: 'verified',
                date: 'Oct 10, 2023'
              }, {
                name: 'Title Search Report (30 Years)',
                status: 'verified',
                date: 'Sep 28, 2023'
              }, {
                name: 'Sale Deed (Previous)',
                status: 'verified',
                date: '2015'
              }, {
                name: 'Mutation Entry (Ferfar)',
                status: 'verified',
                date: '2015'
              }, {
                name: 'Zone Certificate',
                status: 'pending',
                date: 'Nov 01, 2023'
              }, {
                name: 'Demarcation Map',
                status: 'missing'
              }, {
                name: 'Property Tax Receipt',
                status: 'verified',
                date: '2023-24'
              }, {
                name: 'Layout Approval Letter',
                status: 'verified',
                date: '2018'
              }, {
                name: 'NOC from Society',
                status: 'verified',
                date: 'Oct 2023'
              }]} data-id="element-4872" />
                </div>}

              {/* REVIEWS TAB - NEW */}
              {activeTab === 'reviews' && <div className="animate-in fade-in" data-id="element-4873">
                  <ReviewsSection listingId={id || '1'} listingTitle={listingTitle} overallRating={4.7} totalReviews={mockReviews.length} reviews={mockReviews} data-id="element-4874" />
                </div>}

              {/* Q&A TAB - NEW */}
              {activeTab === 'qa' && <div className="animate-in fade-in" data-id="element-4875">
                  <QASection listingTitle={listingTitle} questions={mockQuestions} data-id="element-4876" />
                </div>}
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="lg:col-span-4 space-y-6" data-id="element-4877">
            {/* Seller Card */}
            <div className="bg-white border border-gray-300 p-6 sticky top-24" data-id="element-4878">
              <h3 className="text-sm font-mono font-bold text-gray-500 uppercase mb-4" data-id="element-4879">
                Seller Information
              </h3>
              <div className="flex items-center gap-4 mb-6" data-id="element-4880">
                <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-4881">
                  <User className="w-6 h-6 text-gray-500" data-id="element-4882" />
                </div>
                <div data-id="element-4883">
                  <Link to="/seller/profile/1" className="font-bold text-lg text-[#1f2933] hover:underline" data-id="element-4884">
                    {sellerName}
                  </Link>
                  <p className="text-sm text-gray-500" data-id="element-4885">Individual Owner</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-6 border-t border-b border-dashed border-gray-200 py-4" data-id="element-4886">
                <div className="text-center" data-id="element-4887">
                  <p className="font-bold text-xl text-[#1f2933]" data-id="element-4888">4.8</p>
                  <p className="text-xs text-gray-500 font-mono" data-id="element-4889">Rating</p>
                </div>
                <div className="text-center border-l border-dashed border-gray-200" data-id="element-4890">
                  <p className="font-bold text-xl text-[#1f2933]" data-id="element-4891">Verified</p>
                  <p className="text-xs text-gray-500 font-mono" data-id="element-4892">Identity</p>
                </div>
              </div>

              <button onClick={() => setIsContactOpen(true)} className="w-full py-3 bg-[#1f2933] text-white font-bold mb-3 hover:bg-gray-800 transition-colors" data-id="element-4893">
                Contact Seller
              </button>
              <button onClick={() => setIsScheduleOpen(true)} className="w-full py-3 border border-[#1f2933] text-[#1f2933] font-bold hover:bg-gray-50 transition-colors" data-id="element-4894">
                Schedule Site Visit
              </button>

              <div className="mt-6 p-4 bg-gray-50 border border-dashed border-gray-300 text-xs text-gray-500" data-id="element-4895">
                <div className="flex items-start gap-2" data-id="element-4896">
                  <Shield className="w-4 h-4 shrink-0 mt-0.5" data-id="element-4897" />
                  <p data-id="element-4898">
                    Citiplots protects your contact info. Chat directly through
                    our secure platform.
                  </p>
                </div>
              </div>
            </div>

            {/* Safety Tips */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-4899">
              <h3 className="text-sm font-mono font-bold text-gray-500 uppercase mb-4" data-id="element-4900">
                Transaction Safety
              </h3>
              <ul className="space-y-3 text-sm text-gray-600" data-id="element-4901">
                <li className="flex gap-2" data-id="element-4902">
                  <span className="text-green-600 font-bold" data-id="element-4903">✓</span> Never
                  transfer money before verification.
                </li>
                <li className="flex gap-2" data-id="element-4904">
                  <span className="text-green-600 font-bold" data-id="element-4905">✓</span> Always
                  inspect the plot physically.
                </li>
                <li className="flex gap-2" data-id="element-4906">
                  <span className="text-green-600 font-bold" data-id="element-4907">✓</span> Use
                  Citiplots Escrow for token amounts.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-4908" />

      <ContactSellerModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} sellerName={sellerName} listingTitle={listingTitle} data-id="element-4909" />

      <ScheduleVisitModal isOpen={isScheduleOpen} onClose={() => setIsScheduleOpen(false)} data-id="element-4910" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Downloading Documents" message="Preparing document package... In production, this would create a ZIP file with all verified documents." type="success" data-id="element-4911" />
    </div>;
}